const PointerUtils = {
    disable: (timeout = null) => {
      document.documentElement.style.cursor = "not-allowed"; 
      document.body.style.pointerEvents = "none"; 
  
      if (timeout) {
        setTimeout(() => PointerUtils.enable(), timeout);
      }
    },
  
    enable: () => {
      document.documentElement.style.cursor = "default"; // Reset <html> cursor
      document.body.style.pointerEvents = "auto"; 
    },
  };
  
  export default PointerUtils;
  